import { useIntl } from 'react-intl';
import { Col, Form, Row } from 'react-bootstrap';

import { Dropdown } from 'components/Forms';

interface IAlertsProps {
  handleChange: (type: IFilterLabel, data?: ISelectOption[], value?: string) => any;
  timeLogTypeOptions: ISelectOption[];
  timeLogTypeValue: ISelectOption[];
  timeLogMinValue: string;
  timeLogMaxValue: string;
  minUpperMax: boolean;
  minNegative: boolean;
  maxNegative: boolean;
}

const ClinicalTimeLog = ({
  handleChange,
  timeLogTypeOptions,
  timeLogTypeValue,
  timeLogMinValue,
  timeLogMaxValue,
  minUpperMax,
  minNegative,
  maxNegative
}: IAlertsProps) => {
  const intl = useIntl();

  return (
    <>
      <Dropdown
        dataTestId="filter-timeLogType"
        variant="form"
        options={timeLogTypeOptions}
        onChange={(v: any) => handleChange('timeLogType', v ? [v] : undefined)}
        value={timeLogTypeValue}
        isClearable
        minWidth={200}
        label={
          intl.formatMessage({ id: 'clinicalTimeKey' }) +
          ' (' +
          intl.formatMessage({ id: 'MonthToDate' }) +
          ')'
        }
        placeholder={intl.formatMessage({ id: 'selectTypeKey' })}
      />
      <Row className="mt-2">
        <Col sm={12} md={6}>
          <Form.Label className="pe-2">{intl.formatMessage({ id: 'from' })}</Form.Label>
          <Form.Control
            type="number"
            data-test="timeLogMin"
            value={timeLogMinValue}
            onChange={(e) => handleChange('timeLogMin', undefined, e.target.value)}
            placeholder={intl.formatMessage({ id: 'minMinutesKey' })}
            disabled={!timeLogTypeValue?.length}
            isInvalid={minUpperMax || minNegative}
          />
        </Col>
        <Col sm={12} md={6}>
          <Form.Label className="pe-2 ps-2">{intl.formatMessage({ id: 'to' })}</Form.Label>
          <Form.Control
            type="number"
            data-test="timeLogMax"
            value={timeLogMaxValue}
            onChange={(e) => handleChange('timeLogMax', undefined, e.target.value)}
            placeholder={intl.formatMessage({ id: 'maxMinutesKey' })}
            disabled={!timeLogTypeValue?.length}
            isInvalid={minUpperMax || maxNegative}
          />
        </Col>
      </Row>
    </>
  );
};

export default ClinicalTimeLog;
